import { Card, Descriptions, Flex } from 'antd';

import { Schemas } from '@api-client/generated/types';
import { renderFiles } from '@entities/onboarding/cards/helpers';

import * as S from './styled';

type Person = Schemas.PersonResponseDto;

type CompanyCardProps = {
  company: Person;
};

/** A legal-entity shareholder, read-only — this is all client data, and MDS is taking it over. */
export const CompanyCard = ({ company }: CompanyCardProps) => (
  <S.Container>
    <S.Header align="center" justify="space-between">
      <S.Title level={4}>{company.name}</S.Title>
    </S.Header>

    <Flex gap={8} vertical>
      <Card title="Basic info">
        <Descriptions
          column={2}
          items={[
            {
              key: 'tin',
              label: 'TIN',
              span: 6,
              children: company.kycData.tin ?? '-',
            },
            {
              key: 'commercialRegister ',
              label: 'Commercial register',
              span: 6,
              children: renderFiles(company, 'commercial_register'),
            },
            {
              key: 'aoa ',
              label: 'Articles of Incorporation or Association',
              span: 6,
              children: renderFiles(
                company,
                'article_of_incorporation_or_association'
              ),
            },
            {
              key: 'shareholderRegister',
              label: 'Shareholder register',
              span: 6,
              children: renderFiles(company, 'shareholder_register'),
            },
            {
              key: 'structureChart',
              label: 'Structure chart',
              span: 6,
              children: renderFiles(
                company,
                'chart_with_ownership_and_percents'
              ),
            },
            {
              key: 'lastAnnualAccounts',
              label: 'Last annual accounts',
              span: 6,
              children: renderFiles(company, 'annual_accounts'),
            },
          ]}
          colon={false}
        />
      </Card>
    </Flex>
  </S.Container>
);
